import React from "react";
import RailServicePage from "./RailServicePage";

export default function TrainDeals() {
  return (
    <RailServicePage
      eyebrow="Train Deals"
      title="Find rail deals for your next trip"
      description="Compare flexible dates and popular city pairs to find better-value rail options for regional and long-distance journeys."
      icon="deals"
      highlights={[
        {
          title: "Flexible dates",
          text: "Check nearby dates and departure times to find rail fares that fit your schedule and budget.",
        },
        {
          title: "Popular routes",
          text: "Review commonly booked rail corridors for quick weekend trips, family travel, and business travel.",
        },
      ]}
      steps={[
        "Search your preferred route and date.",
        "Review available departures and estimated fares.",
        "Speak with support to confirm current availability and booking rules.",
      ]}
    />
  );
}
